import { Route } from "react-router-dom";
import { HomeScreen } from "../components/HomeScreen";
import { ChartPage } from "../components/ChartPage";
import { ChatPage } from "../components/chat";
import { ConsultantsPage } from "../components/ConsultantsPage";
import { ProfilePage } from "../components/ProfilePage";
import { RewardsPage } from "../components/RewardsPage";
import { ReferralPage } from "../components/referral/ReferralPage";
import { CompatibilityPage } from "../components/CompatibilityPage";
import { StorePage } from "../components/store/StorePage";
import { BlogPage } from "../components/blog/BlogPage";
import { WorkPage } from "../components/work/WorkPage";
import { LoginPage } from "../components/members/LoginPage";
import { ConsultantDashboard } from "../components/consultants/ConsultantDashboard";
import { BiorhythmPage } from "../pages/BiorhythmPage";
import { LunarPage } from "../pages/LunarPage";
import { TarotPage } from "../pages/TarotPage";
import { MvpLandingPage } from "../pages/MvpLandingPage";

export const mainRoutes = (
  <>
    <Route path="/" element={<HomeScreen />} />
    <Route path="/mvp" element={<MvpLandingPage />} />
    <Route path="/chart" element={<ChartPage />} />
    <Route path="/compatibility" element={<CompatibilityPage />} />
    <Route path="/biorritmo" element={<BiorhythmPage />} />
    <Route path="/lunar" element={<LunarPage />} />
    <Route path="/tarot" element={<TarotPage />} />
    <Route path="/chat" element={<ChatPage />} />
    <Route path="/consultants" element={<ConsultantsPage />} />
    <Route path="/store" element={<StorePage />} />
    <Route path="/rewards" element={<RewardsPage />} />
    <Route path="/referral" element={<ReferralPage />} />
    <Route path="/profile" element={<ProfilePage />} />
    <Route path="/blog" element={<BlogPage />} />
    <Route path="/work" element={<WorkPage />} />
    <Route path="/members" element={<LoginPage />} />
    <Route path="/consultant/dashboard" element={<ConsultantDashboard />} />
  </>
);
